import { useState } from "react";

import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
} from "react-bootstrap";
import { Link } from "react-router-dom";

import { EyeIcon, EyeSlashIcon } from "@/assets/svg/Eye";
import DwellLogo from "@/common/components/DwellLogo";
import Loader from "@/common/components/Loader";
import { PropsFromReduxLogin } from "@/modules/auth/containers/LoginContainer";

const LoginComponent = (props: PropsFromReduxLogin) => {
  const [validated, setValidated] = useState(false);
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (event: any) => {
    setError("");
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      return;
    }
    props
      .logIn(form.email.value, form.password.value)
      .then((result) => {
        if (!result) setError(`L'email ou le mot de passe est incorrect`);
      })
      .catch(() =>
        setError(
          " Les données saisies ne correspondent à aucun compte dans notre base de données. "
        )
      );
    setValidated(true);
  };

  return (
    <div>
      <Container className="d-flex flex-column min-vh-100 justify-content-center align-items-center flex-wrap">
        <Row className="align-items-center justify-content-center">
          <h3 className="text-center mb-0 fw-bold register-title">Bonjour !</h3>
          <h4 className="text-center mt-0 fw-bold register-subtitle">
            Bienvenue sur dwell
          </h4>
          <Form
            className="register-form"
            validated={validated}
            onChange={(e) => setValidated(e.currentTarget.checkValidity())}
            onSubmit={handleSubmit}
          >
            <Form.Group className="mb-3" controlId="email">
              <Form.Control
                type="email"
                placeholder="E-mail professionnel"
                autoComplete="email"
                required
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="password">
              <InputGroup className="d-flex flex-row justify-content-start mb-3">
                <Form.Control
                  className="mr-2"
                  type={passwordVisibility ? "text" : "password"}
                  placeholder="Mot de passe"
                  autoComplete="current-password"
                  required
                />
                <Button
                  variant="outline-primary"
                  onClick={() => setPasswordVisibility(!passwordVisibility)}
                >
                  {passwordVisibility ? <EyeSlashIcon /> : <EyeIcon />}
                </Button>
              </InputGroup>
            </Form.Group>
            {props.isLoading ? (
              <Loader />
            ) : (
              <>
                <div className="text-center">
                  <Button
                    className="mt-4 mb-0 w-100"
                    variant="primary"
                    type="submit"
                    disabled={!validated}
                  >
                    Connexion
                  </Button>
                </div>
                {error !== "" && (
                  <Alert className="mt-4" variant="danger">
                    {error}
                  </Alert>
                )}
                <Form.Group
                  className="mt-3 mb-3 text text-center"
                  controlId="password"
                >
                  <Form.Text id="passwordHelpBlock">
                    <Link to="/forgot-password" className="password-help-link">
                      Mot de passe oublié ?
                    </Link>
                  </Form.Text>
                </Form.Group>
                <Row>
                  <Col className="text text-center mt-2 mb-2">
                    <p className="">OU</p>
                    <Link to="register" className="text-decoration-none">
                      <Button
                        className="mt-2 mb-0 w-100"
                        variant="outline-primary"
                        type="submit"
                      >
                        S'inscrire
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </>
            )}
          </Form>
        </Row>
      </Container>
      <div className="position-absolute top-0 start-0 p-3">
        <DwellLogo linkTo="/login" />
      </div>
    </div>
  );
};

export default LoginComponent;
